import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=23ae7014&scoped=true"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=23ae7014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae7014",
  null
  
)

export default component.exports